<script lang="ts" setup>
import { computed, nextTick, onMounted, ref } from 'vue'

const props = defineProps({
  minWidth: {
    type: [String, Number],
    default: 0,
  },

  maxWidth: {
    type: [String, Number],
    default: Infinity,
  },
})

const viewportWidth = ref<number>(window.innerWidth)

const isVisible = computed<boolean>(
  (): boolean =>
    props.minWidth <= viewportWidth.value &&
    viewportWidth.value <= props.maxWidth,
)

const onWindowResize = (): void => {
  viewportWidth.value = window.innerWidth
}

onMounted(() => {
  nextTick(() => {
    window.addEventListener('resize', onWindowResize)
  })
})
</script>

<template>
  <slot v-if="isVisible"></slot>
</template>
